import {getConfigItem} from '@servicenow/ui-config';
import {DISCONNECTED_TIME} from '@servicenow/ui-internal';
import setInterval from './utils/setInterval';

const garbageCollectors = [];
export const GARBAGE_COLLECTOR_INTERVAL = getConfigItem('ambGC.GARBAGE_COLLECTOR_INTERVAL') || 5000;
export const TIME_TO_WAIT_AFTER_DISCONNECT =
	getConfigItem('ambGC.TIME_TO_WAIT_AFTER_DISCONNECT') || 1000;

setInterval(() => {
	garbageCollectors.forEach(garbageCollector => {
		garbageCollector.__map.forEach((value, key) => {
			if (!value.host.isConnected) {
				// Component has disconnected. To avoid unsubscribing a component that may
				// immediately reconnect, flag the component for removal in the next interval if
				// the component has not already been flagged. If it is already flagged and enough time
				// has passed, remove it.
				if (!value.host[DISCONNECTED_TIME]) value.host[DISCONNECTED_TIME] = Date.now();
				else if (Date.now() - value.host[DISCONNECTED_TIME] > TIME_TO_WAIT_AFTER_DISCONNECT)
					garbageCollector.delete(key);
			}
		});
	});
}, GARBAGE_COLLECTOR_INTERVAL);

export default function createGarbageCollectorMap(cleanup) {
	const map = new Map();

	function remove(key) {
		if (map.has(key)) {
			cleanup(key, map.get(key).value);
			map.delete(key);
		}
	}

	const garbageCollectorMap = {
		set(key, value, host) {
			remove(key);
			map.set(key, {value, host});
		},
		has(key) {
			return map.has(key);
		},
		get(key) {
			const mapValue = map.get(key);

			return mapValue && mapValue.value;
		},
		delete(key) {
			remove(key);
		},
		forEach(callback, thisArg) {
			map.forEach((entry, key) => callback(entry.value, key), thisArg);
		},
		__map: map
	};

	garbageCollectors.push(garbageCollectorMap);

	return garbageCollectorMap;
}
